import { useEffect } from 'react';
import type { CmarkdownvisualMode } from '../Cmarkdownvisual';

interface UseCmarkdowntablePopoverModeTeardownInput {
  mode: CmarkdownvisualMode;
  closePopover: () => void;
}

export function useCmarkdowntablePopoverModeTeardown(
  input: UseCmarkdowntablePopoverModeTeardownInput,
): void {
  const { mode, closePopover } = input;

  useEffect(() => {
    closePopover();
  }, [mode, closePopover]);
}
